module.exports = __webpack_public_path__ + "static/img/logo.445dfbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/assets/img/logo.jpg
// module id = 1NlX
// module chunks = 1